module.exports = __webpack_public_path__ + "e9be9ac31277dbeaa1bb8e6056187254.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/gildan-cotton-tshirt-black.png
// module id = 838
// module chunks = 0